<template>
  <el-dialog
    title="添加教师"
    :visible="dialogShow"
    @open="dialogOpen"
    @close="dialogClose"
    :close-on-click-modal="false"
  >
    <!-- 选择上传教师的方式 -->
    <div class="addteacher-choose-container" v-show="isChooseContainerShow">
      <div
        class="addteacher-teacher-single choose-card-container"
        @click="chooseAddTeacherModeByForm"
      >
        <div class="addteacher-image-container">
          <img src="~@/assets/image/common/single.png" class="type_image" />
        </div>
        <div class="addteacher_type_text">添加单个教师</div>
      </div>
      <div
        class="addteacher-teacher-upload choose-card-container"
        @click="chooseAddTeacherModeByUpload"
      >
        <div class="addteacher-image-container">
          <img src="~@/assets/image/common/upload.png" class="type_image" />
        </div>
        <div class="addteacher_type_text">添加多个教师</div>
      </div>
    </div>
    <div v-show="!isChooseContainerShow">
      <!-- 表单 -->
      <addTeacherForm
        v-show="addTeacherMode == 'form'"
        ref="addTeacherForm"
        :mentorTypeList="mentorTypeList"
        @formSubmit="formSubmit"
      />
      <!-- 上传文件 -->
      <addTeacherUpload
        v-show="addTeacherMode == 'upload'"
        ref="addTeacherUpload"
        @uploadSuccess="uploadSuccess"
      />
    </div>
  </el-dialog>
</template>

<script>
import addTeacherUpload from "../teacher-add-upload/teacher-add-upload.vue";
import addTeacherForm from "../teacher-add-form/teacher-add-form.vue";

export default {
  components: {
    addTeacherUpload,
    addTeacherForm,
  },
  data() {
    return {
      dialogShow: false,
      isChooseContainerShow: true, // 为true时显示两种上传方式供选择，为false根据addTeacherMode的值显示两种上传方式的一种
      addTeacherMode: "",
    };
  },
  watch: {
    isAddTeacherDialogShow() {
      this.dialogShow = this.isAddTeacherDialogShow;
    },
  },
  inject: ["refresh"],
  props: {
    isAddTeacherDialogShow: {
      type: Boolean,
      default: false,
    },
    mentorTypeList: {
      type: Array,
      default: () => [],
    }
  },
  methods: {
    // 打开弹出窗口
    dialogOpen() {
      // 显示两种
      this.isChooseContainerShow = true;
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:isAddTeacherDialogShow", false);
      this.$refs.addTeacherForm.reset();
      this.$refs.addTeacherUpload.reset();
    },
    chooseAddTeacherModeByForm() {
      this.isChooseContainerShow = false;
      this.addTeacherMode = "form";
    },
    chooseAddTeacherModeByUpload() {
      this.isChooseContainerShow = false;
      this.addTeacherMode = "upload";
    },
    // 添加单个教师提交
    formSubmit(data) {
      // console.log(data);
      let { teacherNumber, teacherName, phone, sex, mentorType } = data;
      let { id: schoolId, schoolName } = this.school;
      this.post(this.$url.insertTeacherPC, {
        createBy: this.user.id,
        schoolId,
        schoolName,
        teacherNumber,
        teacherName,
        phone,
        mentorType: mentorType ? mentorType.join(',') : '', 
        sex
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$message.success("添加成功");
            // 刷新列表
            this.refresh();
            // 关闭弹出框
            this.dialogClose();
          } else if (res.code == 601) {
            this.$message.error("手机号格式错误");
          } else if (res.code == 602) {
            this.$message.error("该教师工号已存在，请勿重复添加");
          } else if (res.code == 603) {
            this.$message.error("该教师手机号已存在，请勿重复添加");
          } else {
            this.$message.error("添加失败");
          }
        })
        .catch((err) => {
          this.$message.error("添加失败，请稍后再试");
        });
    },
    // 上传excel成功，关闭弹出框，刷新列表
    uploadSuccess(option) {
      // 刷新列表
      this.refresh();
      // 关闭弹出框
      this.dialogClose();
      if (option.number.length != 0 || option.phone.length != 0) {
        this.$emit("uploadFailList", option);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./teacher-add-dialog.scss";
</style>